import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FilePreview = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9.6627 21.0033H6.21825C5.13122 21.0033 4.25 20.1198 4.25 19.03V4.72333C4.25 3.63349 5.13122 2.75 6.21825 2.75H16.5516C17.6386 2.75 18.5198 3.63349 18.5198 4.72333V10.6433M19.75 21.25L18.4441 19.8984M18.4441 19.8984C19.0995 19.2306 19.504 18.3143 19.504 17.3033C19.504 15.2599 17.8517 13.6033 15.8135 13.6033C13.7753 13.6033 12.123 15.2599 12.123 17.3033C12.123 19.3468 13.7753 21.0033 15.8135 21.0033C16.8433 21.0033 17.7746 20.5804 18.4441 19.8984ZM8.18651 6.69667H14.5833M8.18651 10.6433H11.631'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.5 3.7284C3.5 2.77383 4.27215 2 5.22464 2H17.5435C18.496 2 19.2681 2.77383 19.2681 3.7284V12.4949C18.2973 11.7949 17.1061 11.3827 15.8188 11.3827C12.5532 11.3827 9.9058 14.0358 9.9058 17.3086C9.9058 19.0786 10.68 20.6672 11.9076 21.7531H5.22464C4.27215 21.7531 3.5 20.9793 3.5 20.0247V3.7284ZM6.45652 5.7037C6.45652 5.2946 6.78744 4.96296 7.19565 4.96296H13.6014C14.0097 4.96296 14.3406 5.2946 14.3406 5.7037C14.3406 6.1128 14.0097 6.44444 13.6014 6.44444H7.19565C6.78744 6.44444 6.45652 6.1128 6.45652 5.7037ZM6.45652 9.65432C6.45652 9.24522 6.78744 8.91358 7.19565 8.91358H10.6449C11.0531 8.91358 11.3841 9.24522 11.3841 9.65432C11.3841 10.0634 11.0531 10.3951 10.6449 10.3951H7.19565C6.78744 10.3951 6.45652 10.0634 6.45652 9.65432Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M15.8188 12.8642C13.3696 12.8642 11.3841 14.854 11.3841 17.3086C11.3841 19.7632 13.3696 21.7531 15.8188 21.7531C16.7832 21.7531 17.6764 21.444 18.404 20.9202L19.23 21.7747C19.514 22.0685 19.9819 22.0759 20.2751 21.7913C20.5683 21.5067 20.5758 21.0377 20.2918 20.7439L19.445 19.8678C19.954 19.1444 20.2536 18.2611 20.2536 17.3086C20.2536 14.854 18.2681 12.8642 15.8188 12.8642ZM12.8623 17.3086C12.8623 15.6722 14.186 14.3457 15.8188 14.3457C17.4517 14.3457 18.7754 15.6722 18.7754 17.3086C18.7754 18.1185 18.4522 18.8512 17.9263 19.3868C17.3891 19.9338 16.644 20.2716 15.8188 20.2716C14.186 20.2716 12.8623 18.945 12.8623 17.3086Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
